import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services';
import { tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        console.log("request url "+ request.url);
        
        const currentUser = JSON.parse(this.authService.getCurrentUser());
         
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        } 

        return next.handle(request).pipe(
          tap(
            (event) => {
            },
            (error) => {
                var err_info = error.error;
                var i18n = JSON.parse(sessionStorage.getItem('i18n'));
                if (err_info?.status==401 && err_info?.message==i18n._value['shp.session.error']) {
                    this.authService.logout();
                }
            }
          )
        );
    }

    constructor(private authService: AuthenticationService){

    }
}